import { tv } from "tailwind-variants";

import { mainSectionsPaddings } from "@/common/constants";

export const getArticlesPromoSimpleSectionClass = tv({ base: [mainSectionsPaddings, "bg-tertiary-50"] });

export const getCarouselItemClass = tv({
  base: [
    "basis-11/12 sm:basis-6/12 md:basis-4/12 xl:basis-4/12",
    "animate-duration-300! animate-fill-forwards! opacity-0 group-[.animate-intersected-in]/intersected:animate-fade-left",
  ],
});
